"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadList = downloadList;
exports.download = download;

var _request = _interopRequireDefault(require("@/utils/request"));

var _qs = _interopRequireDefault(require("qs"));

function downloadList(query) {
  return (0, _request.default)({
    url: '/download/list',
    method: 'get',
    params: query,
    paramsSerializer: function paramsSerializer(params) {
      return _qs.default.stringify(params, {
        arrayFormat: 'repeat'
      });
    }
  });
}

function download(query) {
  return (0, _request.default)({
    url: '/download/download',
    method: 'get',
    params: query
  });
}